import { shop as EnUsShop } from '../en-us/shop';
import { AgResourceLanguage } from '../types';

export const shop: AgResourceLanguage['shop'] = {
  ...EnUsShop,
  title: 'Winkel AG1',
  category: 'Categorie',
  allProducts: 'Alle Producten',
  gifts: 'Cadeaus',
  supplements: 'Supplementen',
  subscriptions: 'Abonnementen',
  accessories: 'Accessoires',
  gear: 'Uitrusting',
  button: {
    addToCart: 'Toevoegen aan Winkelwagen',
    addToNextOrder: 'Toevoegen aan Volgende Bestelling',
    subscribe: 'Abonneren',
    addedToNextOrder: 'Toegevoegd aan Volgende Bestelling'
  },
  singleSubscription: 'Enkel Abonnement',
  doubleSubscription: 'Dubbel Abonnement',
  description30: '30 Porties',
  description60: '60 Porties, beste waarde',
  descriptionIndividual30: '30 Individuele porties',
  scoopAvailabilityInfo:
    '*Beschikbaar om toe te voegen aan winkelwagen wanneer er minstens één ander product in de winkelwagen zit',
  scoopPrompt: 'Heb je een schepje nodig bij je zak? Voeg het hieronder gratis toe.'
};
